import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  UpdatesAlertWrapper,
  UpdatesAlertContainer,
  AlertContent,
  AlertText,
  AlertClose,
} from './css';

import SvgIcon from '../../lib/ui/icons/SvgIcon';

const UPDATES_ALERT_STORAGE_KEY = 'updates_alert_dismissed';

const UpdatesAlert = ({ fields }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hasBeenDismissed = typeof window !== 'undefined'
      ? window.localStorage.getItem(UPDATES_ALERT_STORAGE_KEY)
      : false;
    setVisible(!hasBeenDismissed);
  }, []);

  const handleClose = () => {
    window.localStorage.setItem(UPDATES_ALERT_STORAGE_KEY, 'true');
    setVisible(false);
  };

  if (!fields || !fields.content) return null;
  const { content, link } = fields;

  if (visible && content && content.value) {
    return (
      <UpdatesAlertWrapper>
        <UpdatesAlertContainer>
          <AlertContent>

            <AlertText>
              <span>{content.value}</span>
              {
                                (link && link.value && link.value.href && link.value.text)
                                  ? <a href={link.value.href}>{link.value.text}</a> : null
                            }
            </AlertText>

            <AlertClose type="button" onClick={handleClose} aria-describedby="Close alerts bar">
              <SvgIcon icon="CloseIcon" />
            </AlertClose>

          </AlertContent>
        </UpdatesAlertContainer>
      </UpdatesAlertWrapper>
    );
  }

  return null;
};

UpdatesAlert.propTypes = {
  fields: PropTypes.object,
};

const mstp = (state) => ({
  isAuthenticated: state.profile.isAuthenticated,
});

export default connect(mstp, null)(UpdatesAlert);
